import APIController from '../core-api-controller';

//Listing API's

export const fetchPatientsApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/patients${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

//Lead Detail Page API's

export const fetchPatientDetail = (patientId = '') => {
  const path = `${APIController.endpointApi}/patients/${patientId}`;
  return APIController.getApiCallback(path);
};

export const fetchPatientContactsApi = (patientId = '') => {
  const path = `${APIController.endpointApi}/patients/${patientId}/contacts`;
  return APIController.getApiCallback(path);
};

export const fetchPatientMeasurementsApi = (patientId = '') => {
  const path = `${APIController.endpointApi}/patients/${patientId}/measurements`;
  return APIController.getApiCallback(path);
};

export const fetchPatientShortDetail = (patientId = '') => {
  const path = `${APIController.endpointApi}/patients/${patientId}/short_details`;
  return APIController.getApiCallback(path);
};

export const updatePatientDetail = (data, patientId = '') => {
  const path = `${APIController.endpointApi}/patients/${patientId}`;
  return APIController.putCallback(path, data);
};

export const createPatient = (data = {}) => {
  const path = `${APIController.endpointApi}/patients`;
  return APIController.postCallback(path, data);
};

export const createPatientContactApi = (data = {}) => {
  const path = `${APIController.endpointApi}/contacts`;
  return APIController.postCallback(path, data);
};

export const editPatientContactApi = (contactId = '', data = {}) => {
  const path = `${APIController.endpointApi}/contacts/${contactId}`;
  return APIController.putCallback(path, data);
};

export const deletePatientContactApi = (contactId = '') => {
  const path = `${APIController.endpointApi}/contacts/${contactId}`;
  return APIController.deleteCallback(path);
};

export const syncPatientContactApi = (contactId = '') => {
  const path = `${APIController.endpointApi}/contacts/${contactId}/sync`;
  return APIController.getApiCallback(path);
};

export const markFixedPatientContactApi = (contactId = '') => {
  const path = `${APIController.endpointApi}/contacts/${contactId}/mark_as_fixed`;
  return APIController.putCallback(path);
};

export const markUnFixedPatientContactApi = (contactId = '') => {
  const path = `${APIController.endpointApi}/contacts/${contactId}/mark_as_unfixed`;
  return APIController.putCallback(path);
};

export const searchPatientsApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/contacts/search_patients${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchCreditTransactionsApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/credit_transactions${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const addManualCreditTransactionApi = (data = {}) => {
  const path = `${APIController.endpointApi}/credit_transactions/add_manual_transaction`;
  return APIController.postCallback(path, data);
};
